import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import KanbanPage from './KanbanPage';


const Kanban = () => {
    	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
		{ to: '/normative/list', label: 'Normativa' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Kanban' links={breadcrumbLinks} />
					<KanbanPage />
				</Container>
			</div>
		</React.Fragment>
	);
}

export default Kanban;